import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import auth from '../../../service/Auth';
import {file_status} from '../../../service/apis';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GPAP_Button_light, GPAP_Button_Orange } from "../../../../gpap-lib/Button_Collection";
import { CsvButton,downloadCSV } from '../../../service/CsvButton';
import { ReactTableServerSide } from '../../ReactTableServerSide';
import settings from '../../../DataManagementConfig';
import createColumnsTable from "./components/createColumnsTable";

const config = window.config;


const dataHeaders = [
    { label: 'File Name', key: 'file_name'},
    { label: 'Experiment ID', key: 'ExperimentID', tooltip: "Unique Experiment Identifier."},
    { label: 'In Platform', key: 'in_platform', tooltip: "Experiment already pushed to the GPAP platform."},
    { label: 'Processed', key: 'processed',tooltip: "Experiment is successfully processed and ready to be in the GPAP platform."},
    { label: 'Date', key: 'date', tooltip: "Experiment date submission."},
    { label: 'Downloaded', key: 'rawDownload', tooltip:"Experiment files already at HPC cluster."},
    { label: 'Quality Control', key: 'receptionPipeline', tooltip: "Quality checks applied to raw data."},
    { label: 'Mapping', key: 'mapping', tooltip: "Data aligned to the reference genome."},
    { label: 'Cram', key: 'cram', tooltip: "Archiving and visualization crams are generated."},
    { label: 'Coverage', key: 'coverage', tooltip: "Mapping coverage stats calculated."},
    { label: 'Variant Calling', key: 'variantCalling', tooltip: "SNP calls generated in form of chromosome gVCF files."},
    { label: 'Runs of Homozygosity', key: 'rohs', tooltip: "ROHs calls generated."}
];

const statusFields = ["rawDownload","receptionPipeline","mapping", "cram",
                      "coverage","variantCalling","rohs"];

const queryFields = ["ExperimentID", "file_name", "date", "in_platform", "processed","status"];

const fieldsSearchDelayed = ['ExperimentID', 'file_name', 'rawDownload', 'receptionPipeline', 
                             'mapping', 'cram', 'coverage', 'variantCalling', 'rohs'];


const FileStatus =()=>{

    const [pagination, setPagination] = useState({ pageSize: settings.basicPageSize, page: 0, pages: 0,totalItems: 0});
    const [data, setData] = useState([]);
    const [popupErrors, setPopupErrors] = useState("");
    
    const [columns, setColumns] = useState([]);
    const [load, setLoad] = useState(true);

    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState([]);


    const fetchData = async (body) => {
        const queryItems = await file_status(auth.getToken(),config.api_endpoint, JSON.stringify(body))
            .then((response) => { return response.json()})
            .then((data) => {
                setPagination( {
                    page: data["_meta"]["page"],
                    pages: data["_meta"]["total_pages"],
                    totalItems: data["_meta"]["total_items"],
                    pageSize: data["_meta"]["page_size"]}
                );
                return data["items"];
            });
        // 2.1 Parse API Return 
        setColumnsTable();
        setDataTable(queryItems);
    } 

    useEffect(() => {
        // 0.Check token expired 
        if (auth.tokenExpired())
        {
            setPopupErrors("Logging session timeout. Please log again");
        }
        else if (!auth.isUserAdmin()) {
            setPopupErrors("User does not have admin permissions.");
        }
        else {
            // 1. Initialize First Page
            const bodyPost = { 
                "page" : 1, "pageSize" : settings.basicPageSize,
                "fields": queryFields
            }
            // 2. Fetch Data
            fetchData(bodyPost);
        }
    }, [])

    const setColumnsTable = () =>{
        setColumns(createColumnsTable(dataHeaders,statusFields));
    }

    const setDataTable = (items) =>{
        let data = [];
        // 1. Loop over all items
        for (const item of items) {
            let row = {};
            for (const head of dataHeaders){
                if (statusFields.includes(head.key)) {
                    for(const status of item["status"]){
                        row[status["id"]] = status["value"].toString();
                    }
                }else{
                    row[head.key] = item[head.key].toString();
                }
            }
            data.push(row);
        }
        setData(data);
        setLoad(false);
    }

    /*Load Table when user Interacts */
    const loadTableData = (state,instance) => {
        // 0. Set Load Status
        setLoad(true);
        // 1. Set body
        const bodyPost = { 
            "page" : (state.page + 1), 
            "pageSize" : state.pageSize,
            "fields": queryFields
        };
        // 2. Set filtered Criteria
        if (state.filtered) {
            bodyPost["filtered"] = state.filtered.map(item => {
                if (statusFields.includes(item.id)){
                    return { id:item.id, value:item.value};
                }else{
                    return { id:item.id, value:[item.value]};
                }
            })
            setFilter(bodyPost["filtered"]);
        }
        // 3. Check sorted Criteria
        if (state.sorted) {
            bodyPost["sorted"] = state.sorted;
            setSort(bodyPost["sorted"]);
        }
        // 4. Call POST data
        fetchData(bodyPost);
    }

    const getCsvData = async (headers) => {
        // 0. Trigger Load Process
        setLoad(true);
        // 1. Get All Data to be printed to CSV Files
        let dataQuery = {
            "page" : 1,
            "pageSize" : 10000,
            "fields" : queryFields,
            "filtered" : filter,
            "sorted": sort
        };
        let getData = true;
        let allItems = [];
        // 3. Get All Data
        while (getData){
            // 3.1 Call POST Data
            const queryItems = await file_status(auth.getToken(),config.api_endpoint, JSON.stringify(dataQuery))
            .then((response) => { return response.json()})
            .then((data) => {
                allItems.push(...data["items"]);
                if (dataQuery.page < data["_meta"]["total_pages"]){
                    getData = true;
                    dataQuery.page = dataQuery.page + 1;
                }
                else getData = false;
            });
        }
        // 4. Build data for CSV
        let csvData = [];
        for (let item of allItems){
            let row = {};
            //1. Loop Headers
            for (const head of dataHeaders){
                if (statusFields.includes(head.key)) {
                    for(const status of item["status"]){
                        row[status["id"]] = status["value"].toString();;
                    }
                }else{
                    row[head.key] = item[head.key].toString();;
                }
            }
            //2. Add row to data
            csvData.push(row);
        }
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(csvData,dataHeaders,`${today}_files_status.csv`);
        setLoad(false);
    }

    /*Show popup in case an error with the loggin occurs*/
    if (popupErrors != "") {
        return (
            <Popup
                open={true}
            >
            <div>
                <div className="page-header"> <h1> Logging error. </h1> </div>
                <div className="alert alert-warning">{popupErrors} </div>
                <GPAP_Button_Orange href = "#/admin"  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_Orange>
            </div>
            </Popup>);
    }
    else {
        return (
            <div className={"mainContent"}>
                <Typography variant={"h5"} align={"center"}> File analysis status </Typography>
                <GPAP_Button_light href = "#/admin"  startIcon={<ArrowBackIcon />}> Back</GPAP_Button_light>
                <CsvButton getCsvData={getCsvData} />
    
                <ReactTableServerSide
                    headers={dataHeaders}
                    columns={columns}
                    data={data}
                    pagination={ pagination }
                    loadTableData={loadTableData}
                    loading={load}
                    fieldsDelay={fieldsSearchDelayed}
                />
            </div>
        );
    }
} 
 
export default FileStatus;
